import { useQuery } from '@tanstack/react-query';
import dynamic from 'next/dynamic';

import { topbarQueryKeys } from 'lib/queryKeys';

import { useTopbar } from 'providers/TopbarProvider';

import { getTopbarAd } from 'services/ads';

import TopbarDesktop from './Desktop';
import TopbarMobile from './Mobile';

const TopbarAd = dynamic(() => import('./TopbarAd'));

const Topbar = () => {
  const { isTopbarActive } = useTopbar();

  const { data: topbarAd } = useQuery({
    queryKey: topbarQueryKeys.bannerAd(),
    queryFn: ({ signal }) => getTopbarAd({ signal }),
    cacheTime: Infinity,
    enabled: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  if (!isTopbarActive) {
    return null;
  }

  return (
    <>
      {topbarAd && <TopbarAd {...topbarAd} />}
      <header className="sticky top-0 z-40 w-full transition-all duration-150 ease-in lg:mb-12">
        <TopbarDesktop />
        <TopbarMobile className="lg:hidden" />
      </header>
    </>
  );
};

export default Topbar;
